<script setup>
/* global axios */
// Asistani SOHBET EDEREK egitme ekrani.
//
// Yonetici gunluk dille yaziyor ("kargo 2 gunde cikiyor", "indirim
// isteyene sunu de"); sistem bunu ya BILGI (soru/cevap, asistan
// sorulunca buluyor) ya da KURAL (her yanitta gecerli davranis) olarak
// oneriyor. Uygulanmadan once yonetici goruyor ve onayliyor: yanlis
// anlasilan bir cumle asistanin davranisini sessizce degistirmemeli.
import { computed, nextTick, onMounted, onUnmounted, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRoute } from 'vue-router';
import { useAlert } from 'dashboard/composables';
import PageLayout from 'dashboard/components-next/captain/PageLayout.vue';
import Button from 'dashboard/components-next/button/Button.vue';
import Spinner from 'dashboard/components-next/spinner/Spinner.vue';

const { t } = useI18n();
const route = useRoute();

const YOKLAMA_MS = 2000;
const AZAMI_YOKLAMA = 60;

const taban = computed(
  () => `/api/v1/accounts/${route.params.accountId}/egitim/${route.params.assistantId}`
);
const isTabani = computed(
  () => `/api/v1/accounts/${route.params.accountId}/egitim/is`
);

const mesajlar = ref([]);
const girdi = ref('');
const calisiyor = ref(false);
const yukleniyor = ref(true);
const bilgiler = ref([]);
const kurallar = ref([]);
const liste = ref(null);

let zamanlayici = null;
const durdur = () => {
  if (zamanlayici) clearTimeout(zamanlayici);
  zamanlayici = null;
};
onUnmounted(durdur);

const enAlta = async () => {
  await nextTick();
  if (liste.value) liste.value.scrollTop = liste.value.scrollHeight;
};

const ekle = async (kim, metin, oneri = null) => {
  mesajlar.value.push({ kim, metin, oneri, id: `${Date.now()}-${mesajlar.value.length}` });
  await enAlta();
};

const ogrenilenleriYukle = async () => {
  try {
    const { data } = await axios.get(taban.value);
    bilgiler.value = data.bilgiler || [];
    kurallar.value = data.kurallar || [];
  } catch (e) {
    bilgiler.value = [];
    kurallar.value = [];
  } finally {
    yukleniyor.value = false;
  }
};

onMounted(async () => {
  await ogrenilenleriYukle();
  ekle('sistem', t('OMNUP_EGITIM.KARSILAMA'));
});

const isiBekle = isId =>
  new Promise((coz, reddet) => {
    let kalan = AZAMI_YOKLAMA;
    const bak = async () => {
      kalan -= 1;
      if (kalan <= 0) {
        reddet(new Error(t('OMNUP_EGITIM.ZAMAN_ASIMI')));
        return;
      }
      try {
        const { data } = await axios.get(`${isTabani.value}/${isId}`);
        if (data.durum === 'calisiyor') {
          zamanlayici = setTimeout(bak, YOKLAMA_MS);
          return;
        }
        if (data.durum === 'hazir') coz(data.sonuc?.oneri || {});
        else reddet(new Error(data.hata || t('OMNUP_EGITIM.HATA')));
      } catch (e) {
        reddet(new Error(e?.response?.data?.error || t('OMNUP_EGITIM.HATA')));
      }
    };
    zamanlayici = setTimeout(bak, YOKLAMA_MS);
  });

const gonder = async () => {
  const metin = girdi.value.trim();
  if (!metin || calisiyor.value) return;

  girdi.value = '';
  await ekle('yonetici', metin);
  calisiyor.value = true;
  try {
    const gecmis = mesajlar.value
      .filter(m => m.kim === 'yonetici')
      .slice(-6)
      .map(m => m.metin);
    const { data } = await axios.post(`${taban.value}/yorumla`, { mesaj: metin, gecmis });
    const oneri = await isiBekle(data.is_id);
    if (oneri.tur === 'belirsiz') {
      await ekle('sistem', oneri.netlestir || t('OMNUP_EGITIM.NETLESTIR'));
    } else {
      await ekle('sistem', oneri.ozet || t('OMNUP_EGITIM.ONERI_HAZIR'), oneri);
    }
  } catch (e) {
    await ekle('sistem', e.message || t('OMNUP_EGITIM.HATA'));
  } finally {
    calisiyor.value = false;
    durdur();
  }
};

const onayla = async mesaj => {
  const oneri = mesaj.oneri;
  if (!oneri) return;

  try {
    await axios.post(`${taban.value}/uygula`, {
      tur: oneri.tur,
      soru: oneri.soru,
      cevap: oneri.cevap,
      kural: oneri.kural,
    });
    mesaj.oneri = null;
    mesaj.eklendi = true;
    useAlert(t('OMNUP_EGITIM.EKLENDI'));
    await ogrenilenleriYukle();
    await ekle('sistem', t('OMNUP_EGITIM.EKLENDI_MESAJ'));
  } catch (e) {
    useAlert(e?.response?.data?.error || t('OMNUP_EGITIM.HATA'));
  }
};

const vazgec = mesaj => {
  mesaj.oneri = null;
  mesaj.iptal = true;
};

const bilgiSil = async bilgi => {
  try {
    await axios.delete(`${taban.value}/bilgi/${bilgi.id}`);
    await ogrenilenleriYukle();
    useAlert(t('OMNUP_EGITIM.SILINDI'));
  } catch (e) {
    useAlert(e?.response?.data?.error || t('OMNUP_EGITIM.HATA'));
  }
};

const kuralSil = async kural => {
  try {
    await axios.post(`${taban.value}/kural-sil`, { kural });
    await ogrenilenleriYukle();
    useAlert(t('OMNUP_EGITIM.SILINDI'));
  } catch (e) {
    useAlert(e?.response?.data?.error || t('OMNUP_EGITIM.HATA'));
  }
};

const enterBasildi = olay => {
  if (olay.isComposing || olay.shiftKey) return;
  olay.preventDefault();
  gonder();
};
</script>

<template>
  <PageLayout show-assistant-switcher :show-pagination-footer="false" :show-know-more="false" class="h-full">
    <template #body>
      <div class="flex flex-col h-full gap-4 lg:flex-row">
        <!-- Sohbet -->
        <div class="flex flex-col flex-1 min-h-0 py-6 border rounded-xl border-n-weak">
          <div class="px-6 mb-4">
            <h3 class="mb-1 text-lg font-medium text-n-slate-12">
              {{ t('OMNUP_EGITIM.BASLIK') }}
            </h3>
            <p class="text-sm text-n-slate-11">{{ t('OMNUP_EGITIM.ACIKLAMA') }}</p>
          </div>

          <div ref="liste" class="flex-1 px-6 overflow-y-auto space-y-4">
            <div
              v-for="mesaj in mesajlar"
              :key="mesaj.id"
              class="flex"
              :class="mesaj.kim === 'yonetici' ? 'justify-end' : 'justify-start'"
            >
              <div
                class="max-w-[85%] px-4 py-3 text-sm rounded-xl"
                :class="
                  mesaj.kim === 'yonetici'
                    ? 'bg-n-solid-blue text-n-slate-12 rounded-br-sm'
                    : 'bg-n-alpha-2 text-n-slate-12 rounded-bl-sm'
                "
              >
                <p class="mb-0 whitespace-pre-line">{{ mesaj.metin }}</p>

                <!-- Oneri karti -->
                <div v-if="mesaj.oneri" class="flex flex-col gap-2 p-3 mt-3 rounded-lg bg-n-background">
                  <span class="text-[11px] uppercase tracking-wide text-n-slate-11">
                    {{
                      mesaj.oneri.tur === 'kural'
                        ? t('OMNUP_EGITIM.TUR_KURAL')
                        : t('OMNUP_EGITIM.TUR_BILGI')
                    }}
                  </span>
                  <template v-if="mesaj.oneri.tur === 'bilgi'">
                    <span class="text-xs text-n-slate-11">{{ t('OMNUP_EGITIM.SORU') }}</span>
                    <span class="text-sm text-n-slate-12">{{ mesaj.oneri.soru }}</span>
                    <span class="mt-1 text-xs text-n-slate-11">{{ t('OMNUP_EGITIM.CEVAP') }}</span>
                    <span class="text-sm text-n-slate-12">{{ mesaj.oneri.cevap }}</span>
                  </template>
                  <span v-else class="text-sm text-n-slate-12">{{ mesaj.oneri.kural }}</span>

                  <div class="flex gap-2 mt-1">
                    <Button size="sm" :label="t('OMNUP_EGITIM.ONAYLA')" @click="onayla(mesaj)" />
                    <Button
                      size="sm"
                      variant="ghost"
                      color="slate"
                      :label="t('OMNUP_EGITIM.VAZGEC')"
                      @click="vazgec(mesaj)"
                    />
                  </div>
                </div>

                <p v-if="mesaj.eklendi" class="mt-2 mb-0 text-xs text-n-teal-11">
                  {{ t('OMNUP_EGITIM.EKLENDI') }}
                </p>
                <p v-if="mesaj.iptal" class="mt-2 mb-0 text-xs text-n-slate-11">
                  {{ t('OMNUP_EGITIM.VAZGECILDI') }}
                </p>
              </div>
            </div>

            <div v-if="calisiyor" class="flex items-center gap-2 text-sm text-n-slate-11">
              <Spinner class="text-n-brand size-4" />
              {{ t('OMNUP_EGITIM.DUSUNUYOR') }}
            </div>
          </div>

          <div class="flex items-end gap-2 p-3 mx-6 mt-4 rounded-xl bg-n-background outline outline-1 outline-n-weak">
            <textarea
              v-model="girdi"
              rows="2"
              class="flex-1 mb-0 text-sm bg-transparent border-none resize-none focus:outline-none text-n-slate-12 placeholder:text-n-slate-10"
              :placeholder="t('OMNUP_EGITIM.YER_TUTUCU')"
              @keydown.enter="enterBasildi"
            />
            <Button
              size="sm"
              :disabled="!girdi.trim() || calisiyor"
              :label="t('OMNUP_EGITIM.GONDER')"
              @click="gonder"
            />
          </div>
        </div>

        <!-- Ogrenilenler -->
        <div class="flex flex-col w-full gap-4 p-6 overflow-y-auto border lg:w-96 rounded-xl border-n-weak">
          <div>
            <h3 class="mb-1 text-base font-medium text-n-slate-12">
              {{ t('OMNUP_EGITIM.OGRENILENLER') }}
            </h3>
            <p class="text-xs text-n-slate-11">{{ t('OMNUP_EGITIM.OGRENILENLER_NOT') }}</p>
          </div>

          <div v-if="yukleniyor" class="flex justify-center p-4">
            <Spinner class="text-n-brand" />
          </div>

          <template v-else>
            <div class="flex flex-col gap-2">
              <span class="text-xs font-medium uppercase text-n-slate-11">
                {{ t('OMNUP_EGITIM.KURALLAR') }} ({{ kurallar.length }})
              </span>
              <p v-if="!kurallar.length" class="mb-0 text-xs text-n-slate-10">
                {{ t('OMNUP_EGITIM.KURAL_YOK') }}
              </p>
              <div
                v-for="kural in kurallar"
                :key="kural"
                class="flex items-start justify-between gap-2 p-3 text-sm rounded-lg bg-n-alpha-1 text-n-slate-12"
              >
                <span>{{ kural }}</span>
                <Button
                  size="xs"
                  variant="ghost"
                  color="ruby"
                  icon="i-lucide-trash"
                  @click="kuralSil(kural)"
                />
              </div>
            </div>

            <div class="flex flex-col gap-2">
              <span class="text-xs font-medium uppercase text-n-slate-11">
                {{ t('OMNUP_EGITIM.BILGILER') }} ({{ bilgiler.length }})
              </span>
              <p v-if="!bilgiler.length" class="mb-0 text-xs text-n-slate-10">
                {{ t('OMNUP_EGITIM.BILGI_YOK') }}
              </p>
              <div
                v-for="bilgi in bilgiler"
                :key="bilgi.id"
                class="flex items-start justify-between gap-2 p-3 rounded-lg bg-n-alpha-1"
              >
                <span class="flex flex-col gap-1">
                  <span class="text-sm font-medium text-n-slate-12">{{ bilgi.soru }}</span>
                  <span class="text-xs text-n-slate-11">{{ bilgi.cevap }}</span>
                </span>
                <Button
                  size="xs"
                  variant="ghost"
                  color="ruby"
                  icon="i-lucide-trash"
                  @click="bilgiSil(bilgi)"
                />
              </div>
            </div>
          </template>
        </div>
      </div>
    </template>
  </PageLayout>
</template>
